// extracted by mini-css-extract-plugin
export default {"advertCardList":"c-a_hr","advertCardList_max6":"c-a_hs"};